"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _table = _interopRequireDefault(require("antd/lib/table"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Util = require("../util/Util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {};
const columns = [// {
//   title: 'ID',
//   dataIndex: 'id',
//   key: 'id',
//   sorter: (a: any, b: any) => a.id - b.id
// },
{
  title: 'Created Date',
  dataIndex: 'createDate',
  key: 'createDate',
  render: _Util.renderDateWithTime,
  sorter: (a, b) => {
    return (0, _moment.default)(a.createDate || 0).unix() - (0, _moment.default)(b.createDate || 0).unix();
  },
  width: '200px',
  defaultSortOrder: 'descend'
}, {
  title: 'Admin',
  dataIndex: 'adminUsername',
  key: 'adminUsername',
  sorter: (a, b) => `${a.adminUsername}`.localeCompare(b.adminUsername),
  width: '100px'
}, {
  title: 'Note',
  dataIndex: 'body',
  key: 'body',
  sorter: (a, b) => `${a.body}`.localeCompare(b.body)
}];

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class NotesTable extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: this.props.notes,
      pagination: false,
      rowClassName: rowClassName,
      rowKey: "id"
    });
  }

}

NotesTable.defaultProps = {};

var _default = (0, _reactRedux.connect)(null, null)(NotesTable);

exports.default = _default;